import React from "react";
import { Form, Button, Alert } from "react-bootstrap";

const ContactForm = ({ formData, handleChange, handleSubmit, status }) => {
  return (
    <>
      {status.message && (
        <Alert variant={status.success ? "success" : "danger"}>
          {status.message}
        </Alert>
      )}

      {!status.success && (
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="firstname" className="mb-3">
            <Form.Control
              type="text"
              placeholder="First Name"
              name="firstname"
              value={formData.firstname}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group controlId="name" className="mb-3">
            <Form.Control
              type="text"
              placeholder="Last Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group controlId="email" className="mb-3">
            <Form.Control
              type="email"
              placeholder="Your Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group controlId="phone" className="mb-3">
            <Form.Control
              type="phone"
              placeholder="Phone Number"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group controlId="comment" className="mb-3">
            <Form.Control
              as="textarea"
              rows={4}
              placeholder="Your Message"
              name="comment"
              value={formData.comment}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group controlId="pro" className="mb-3 text-start">
            <Form.Check
              type="checkbox"
              label="I'm a pro (business contact)"
              name="pro"
              checked={formData.pro}
              onChange={handleChange}
            />
          </Form.Group>

          <Button variant="outline-secondary" type="submit">
            Submit
          </Button>
        </Form>
      )}
    </>
  );
};

export default ContactForm;
